module.exports = __webpack_public_path__ + "static/apple-icon-152x152-80af52833b8560ad13d6f514bc77708a.png";